import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useHouseHoldVisitChartsDataContext } from './hooks/useHouseHoldVisitChartsDataContext';

export const Indicators = () => {
    const { chartData } = useHouseHoldVisitChartsDataContext();

    return (
        <div className="w-100">
            <Card
                title="Total de Visitas Domiciliares"
                value={number.formatToBRNumber(
                    chartData?.indicators?.totalHouseHold || 0
                )}
            />
        </div>
    );
};
